import Text from '@sats-group/ui-lib/react/text';
import cn from 'classnames';
import React from 'react';
import type { NodeType, OptionCard as Props } from './option-card.types';

const innerType = {
  button: 'button',
  link: 'a',
  radio: 'label',
} as const;

/** https://www.figma.com/design/CemEcLe6DpoD5ELrFqlwZ7/shared-web-components?node-id=13654-17527 */
const OptionCard = <T extends NodeType>({
  description,
  disabled,
  horizontal,
  icon,
  onInteraction,
  selected,
  testId,
  title,
  type,
}: Props<T>) => (
  <div className="option-card">
    {type.name === 'radio' ? (
      <input
        className="option-card__radio"
        disabled={disabled}
        id={type.props.id}
        name={type.props.name}
        onChange={onInteraction ? () => onInteraction(type.props) : undefined}
        required={type.props.required}
        type="radio"
        value={type.props.value}
      />
    ) : null}
    {React.createElement(
      disabled ? 'div' : innerType[type.name],
      {
        className: cn('option-card__content', {
          'option-card__content--disabled': disabled,
          'option-card__content--horizontal': horizontal,
          'option-card__content--selected': selected,
        }),
        'data-testid': testId,
        disabled,
        for: type.name === 'radio' ? type.props.id : undefined,
        onClick: onInteraction ? () => onInteraction(type.props) : undefined,
      },
      <div
        className={cn('option-card__icon', {
          'option-card__icon--active': selected,
          'option-card__icon--dim': disabled,
        })}
      >
        {icon.type === 'node' ? (
          icon.content
        ) : (
          <div dangerouslySetInnerHTML={{ __html: icon.content }} />
        )}
      </div>,
      <div className="option-card__text">
        <div
          className={cn('option-card__title', {
            'option-card__title--dim': disabled,
          })}
        >
          <Text theme={Text.themes.emphasis} tight>
            {title}
          </Text>
        </div>
        <div
          className={cn('option-card__description', {
            'option-card__description--active': selected,
            'option-card__description--dim': disabled,
          })}
        >
          <Text size={Text.sizes.small} tight>
            {description}
          </Text>
        </div>
      </div>
    )}
  </div>
);

export default OptionCard;
